var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEasyMon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 943.92 942.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    "data-name": "Gradiente sem nome 14",
    x1: 0,
    y1: 471.49,
    x2: 943.92,
    y2: 471.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e84b21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-2",
    "data-name": "Gradiente sem nome 14",
    x1: 423.92,
    y1: 443.29,
    x2: 710.38,
    y2: 443.29,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-3",
    "data-name": "Gradiente sem nome 14",
    x1: 494.2,
    y1: 194.81,
    x2: 690.39,
    y2: 194.81,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-4",
    "data-name": "Gradiente sem nome 14",
    x1: 493.8,
    y1: 748.2,
    x2: 691.01,
    y2: 748.2,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-5",
    "data-name": "Gradiente sem nome 14",
    x1: 140.09,
    y1: 591.7,
    x2: 250.72,
    y2: 591.7,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-6",
    "data-name": "Gradiente sem nome 14",
    x1: 253.61,
    y1: 194.54,
    x2: 450.5,
    y2: 194.54,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-7",
    "data-name": "Gradiente sem nome 14",
    x1: 139.93,
    y1: 351.24,
    x2: 250.93,
    y2: 351.24,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-8",
    "data-name": "Gradiente sem nome 14",
    x1: 253.75,
    y1: 748.21,
    x2: 450.53,
    y2: 748.21,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-9",
    "data-name": "Gradiente sem nome 14",
    x1: 694.23,
    y1: 591.39,
    x2: 804.16,
    y2: 591.39,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-10",
    "data-name": "Gradiente sem nome 14",
    x1: 694.19,
    y1: 351.6,
    x2: 804.37,
    y2: 351.6,
    xlinkHref: "#Gradiente_sem_nome_14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m943.92,471.78c-.29,258.93-209.95,470.87-471.28,471.2C217.69,943.3,2.22,739.13,0,470.52,3.22,200.93,221.37-2.83,477.45.03c257.97,2.88,466.45,212.97,466.47,471.75Zm-471.81,400.36c224.1-.85,397.29-181.82,400.79-394.18,3.57-216.74-170.34-406.84-400.54-406.88-225.31-.04-397.08,181.73-400.75,393.22-3.85,221.51,174.56,406.95,400.51,407.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m710.38,367.63c-11.44,6.5-22.87,13.01-34.31,19.5-49.95,28.31-99.89,56.65-149.89,84.88-3.76,2.13-5.74,4.61-6.58,9.11-4.25,22.67-24.14,38.72-47.3,38.73-23.24.01-43.26-15.91-47.43-38.61-4.01-21.83,4.8-40.24,22.14-51.06,16.96-10.57,39.34-9.52,54.86,3.28,4.8,3.96,8.52,4,13.86,2.09,64.01-22.84,128.1-45.47,192.16-68.16.64-.23,1.29-.42,1.94-.63.18.29.35.59.53.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m494.2,180.79v-41.1c29.6,1.2,57.89,7.34,85.54,16.59,46.35,15.49,91.4,44.58,110.65,64.64-9.45,9.45-18.89,18.89-29.01,29-47.74-40.34-103.77-63.6-167.19-69.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m661.61,692.82c9.92,9.98,19.33,19.46,29.4,29.6-22.72,20.17-48.52,37.01-76.68,50.26-37.83,17.8-77.57,28.15-120.39,30.9-.25-13.94-.12-27.22-.04-41.24,31.29-3.06,61.21-9.7,89.82-21.68,28.62-11.98,54.66-28.16,77.89-47.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m250.72,660.62c-9.91,9.89-19.36,19.33-29.47,29.43-17.55-19.32-32.33-41.43-44.68-65.19-21.2-40.8-33.31-84.15-36.48-129.93,5.38-1.82,33.18-2.14,41.41-.47,2.8,30.59,9.71,60.43,21.71,89.02,11.91,28.37,28.01,54.18,47.5,77.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m450.49,139.34c0,13.6,0,25.82-.02,38.05,0,.9-.29,1.8-.59,3.47-63.01,5.44-118.83,28.68-166.52,68.88-10.07-9.97-19.69-19.49-29.76-29.45,56.19-48.25,121.5-75.39,196.88-80.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m221.24,252.55c10.32,10.25,19.79,19.66,29.69,29.5-40.48,47.9-63.81,103.55-69.46,167.39-13.77.79-27.19.46-41.54.24,5.64-75.49,32.86-140.65,81.32-197.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m450.53,762.2c0,12.78,0,24.52-.01,36.26,0,1.37-.18,2.74-.33,4.97-30.04-1.59-58.79-7.6-86.83-17.27-40.93-14.12-77.61-35.51-109.6-63.4,9.94-10.08,19.44-19.71,29.37-29.78,23.14,19.73,49.26,35.84,77.89,47.78,28.41,11.84,58.08,18.66,89.52,21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m723.51,689.42c-9.62-9.59-19.2-19.14-29.28-29.2,19.11-22.87,35.33-48.61,47.17-77.04,11.84-28.42,18.8-58.02,21.61-89.25,13.72-.94,26.96-.49,41.16-.29-1.23,29.29-7.17,56.91-16.14,83.93-13.62,41.04-44.25,93.56-64.52,111.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m804.37,448.91c-2.52.45-3.87.88-5.22.89-10.12.07-20.24.14-30.36.02-5.41-.07-5.88-.64-6.43-6.13-5.97-60.02-28.53-113.06-67.04-159.41-.6-.72-1.11-1.5-1.13-1.53,9.75-9.72,19.33-19.28,29.52-29.45,20.77,23.42,38.18,50.51,51.67,80.14,16.62,36.49,26.41,74.7,28.99,115.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEasyMon);
export default __webpack_public_path__ + "static/media/IconEasyMon.1ee4542569c152ec14af18ce85e1c864.svg";
export { ForwardRef as ReactComponent };